import gql from 'graphql-tag';

export const EditorPreferencesMutation = gql`
	mutation EditorPreferencesMutation($toolbarDockingInitialPosition: String!) {
		updateUserPreferences(
			userPreferences: {
				confluenceEditorSettingsInput: {
					toolbarDockingInitialPosition: $toolbarDockingInitialPosition
				}
			}
		) {
			confluenceEditorSettings {
				toolbarDockingInitialPosition
			}
		}
	}
`;
